import React, { ReactElement } from "react";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import Link from "next/link";
import { DesktopNavMenuItem } from "./desktopNavMenuItem";
import { ChevronDown } from "@untitled-ui/icons-react";
import styles from "./desktopNavMenu.module.scss";
import classNames from "classnames";

export const DesktopNavMenu = (props: Props): ReactElement => {
  return (
    <NavigationMenu.Root
      style={{
        display: "flex",
        justifyContent: "center",
        zIndex: 1,
        alignItems: "center",
      }}
    >
      <NavigationMenu.List
        style={{
          listStyle: "none",
          display: "flex",
          justifyContent: "center",
          margin: "0 -16px",
          padding: "0",
          gap: "0px",
        }}
      >
        {props.menus?.map((menu, i) => (
          <NavigationMenu.Item
            style={{
              position: "relative",
            }}
            key={i}
          >
            {menu.url ? (
              <NavigationMenu.Link
                className={styles.link}
                asChild
                onClick={menu.onClick}
              >
                <Link href={menu.url}>{menu.title}</Link>
              </NavigationMenu.Link>
            ) : (
              <>
                <NavigationMenu.Trigger
                  className={classNames(styles.triggerStyle, {
                    [styles.studentGradientTriggerStyle]:
                      menu.type === "blue_gradient",
                    [styles.tutorGradientTriggerStyle]:
                      menu.type === "green_gradient",
                  })}
                  onClick={(e) => e.preventDefault()}
                >
                  {menu.title}
                  <ChevronDown
                    style={{
                      transition: "transform 250ms ease",
                    }}
                  />
                </NavigationMenu.Trigger>
                <NavigationMenu.Content className={styles.menuContent}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {menu.items?.map((item, j) => (
                      <NavigationMenu.Link asChild key={j}>
                        <DesktopNavMenuItem
                          title={item.title}
                          desc={item.desc}
                          icon={item.icon}
                          url={item.url}
                          badgeText={item.badgeText}
                          badgeColor={item.badgeColor}
                          onClick={item.onClick}
                        />
                      </NavigationMenu.Link>
                    ))}
                  </div>
                </NavigationMenu.Content>
              </>
            )}
          </NavigationMenu.Item>
        ))}
      </NavigationMenu.List>
    </NavigationMenu.Root>
  );
};

interface Props {
  menus: {
    title: string;
    url?: string;
    type?: "blue_gradient" | "green_gradient";
    items?: {
      title: string;
      desc?: string;
      icon?: JSX.Element;
      url: string;
      badgeText?: string;
      badgeColor?: "green" | "blue" | "red" | "gray";
      onClick?: () => void;
    }[];
    onClick?: () => void;
  }[];
}
